import { Paper, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import {
  FadeInContainer,
  GlobalContainer,
} from "../../../components/AtomicDesign/Atoms";
import { UpdateMyUser } from "../../../components/AtomicDesign/Organisms";

import useAuth from "../../../hooks/context/useAuth";
import { useLocation } from "react-router-dom";
import { MyOrders } from "../componentsPage/MyOrders";
import { colors } from "../../../theme/colors";

export function MyInfo() {
  const [activeTab, setActiveTab] = useState(2);
  const [selectedColor, setColor] = useState("");
  const [userInfo, setUserInfo] = useState({} as User);
  const { getUser, user } = useAuth();
  const { pathname } = useLocation();

  const getUserData = async (id: number) => {
    const userGet = (await getUser(id)) as any;
    setUserInfo(userGet);
  };

  useEffect(() => {
    setColor("#FFF");
  }, [pathname]);

  useEffect(() => {
    if (user?.user?.id && activeTab === 0) {
      getUserData(user?.user?.id);
    }

    //eslint-disable-next-line
  }, [activeTab, user]);

  return (
    <GlobalContainer sx={{ p: 0 }}>
      <FadeInContainer>
        <Tabs
          value={activeTab}
          onChange={(_e, value) => setActiveTab(value)}
          aria-label="disabled tabs example"
          variant={"fullWidth"}
          TabIndicatorProps={{
            style: { background: colors.purple[700], color: "red" },
          }}
          sx={{
            "& .Mui-selected": {
              background: colors.purple[500],
              color: selectedColor,
            },
            "& .MuiTab-root": {
              fontSize: 16,
              fontWeight: 500,
              "&: hover": {
                background: colors.purpleAlpha[500],
              },
              "&: focus": {
                background: colors.purple[500],
              },
            },
          }}
        >
          <Tab label="Meus pedidos" value={2} onClick={() => setActiveTab(2)} />
          <Tab
            label="Minhas informações"
            value={0}
            onClick={() => setActiveTab(0)}
          />
        </Tabs>
        <Paper
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: activeTab === 2 ? 0 : 2,
            p: activeTab === 2 ? 0 : 5,
            maxWidth: "1920px",
          }}
          elevation={activeTab === 2 ? 0 : 3}
        >
          {activeTab === 0 && <UpdateMyUser userData={userInfo} />}
          {activeTab === 2 && <MyOrders />}
        </Paper>
      </FadeInContainer>
    </GlobalContainer>
  );
}
